const TIME = new Intl.DateTimeFormat('en-GB', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});
const WEEKDAY = new Intl.DateTimeFormat('en-GB', { weekday: 'short' });
const DAY_MONTH = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' });
const DAY_MONTH_YEAR = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

const DAY_MS = 24 * 60 * 60 * 1000;

function startOfDay(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

/** List dates the way a mail client shows them: time today, weekday this week, date beyond. */
export function relativeDate(iso: string, now: Date = new Date()): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const days = Math.round((startOfDay(now) - startOfDay(date)) / DAY_MS);
  if (days === 0) return TIME.format(date);
  if (days > 0 && days < 7) return WEEKDAY.format(date);
  if (date.getFullYear() === now.getFullYear()) return DAY_MONTH.format(date);
  return DAY_MONTH_YEAR.format(date);
}

/** The same instant in full, for the places a relative date is not precise enough. */
export function fullDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return `${DAY_MONTH_YEAR.format(date)} ${TIME.format(date)}`;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${Math.max(0, Math.round(bytes))} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${Math.round(kb)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
}

/** Initials for an avatar. Falls back to the address when there is no display name. */
export function initialsOf(name: string | undefined, address: string): string {
  const source = name === undefined || name.trim() === '' ? (address.split('@')[0] ?? '') : name;
  const words = source.split(/[\s._-]+/).filter((word) => word !== '');
  const letters = words.slice(0, 2).map((word) => word[0] ?? '');
  return letters.join('').toUpperCase() || '?';
}
